module.exports = "https://img1.huilianyi.com/3/cover.36dead1245.appcore.png";